class BaselineProphyQuestionnaire {
  // takes two arguments: first is string name of molecule (e.g. 'Botox')
  // second is array of possible dosage choice labels (2-3, e.g. ['70mg every week', '140mg every week'])
  constructor (molecule, dosage) {
    this.molecule = molecule
    this.id = 'baselineProphy' + molecule
    this.title = `Prophy Baseline ${this.molecule}`
    this.theme = {
      'href': 'https://api.typeform.com/themes/G69ViG'
    }
    this.workspace = {
      'href': 'https://api.typeform.com/workspaces/11680930'
    }
    this.settings = {
      'is_public': true,
      'is_trial': false,
      'language': 'en',
      'progress_bar': 'percentage',
      'show_progress_bar': true,
      'show_typeform_branding': false,
      'redirect_after_submit_url': 'https://healint.typeform.com/to/dUeK7M?prophy={{hidden:prophy}}&month=',
      'meta': {
        'allow_indexing': false
      }
    }
    this.thankyou_screens = [
      {
        'ref': 'default_tys',
        'title': 'Done! Your information was sent perfectly.',
        'properties': {
          'show_button': true,
          'share_icons': false
        }
      }
    ]

    let previousMedications = [
      {
        'molecule': 'Botox',
        'id': 'GfhMwANAhkqa',
        'ref': '9842b384-3070-455c-afb9-020efbf840f1',
        'label': 'Botulinum Toxin A (e.g. Botox)'
      },
      {
        'molecule': 'Topiramate',
        'id': 'LhrLQdzpGeIo',
        'ref': '482319a6-05b6-403a-a3a9-27b0f781f620',
        'label': 'Topiramate (e.g. Topamax, Trokendi XR)'
      },
      {
        'molecule': 'Propanolol',
        'id': 'UMk876YJBG6Q',
        'ref': '8c48966c-5a1e-424f-8565-b98979b57666',
        'label': 'Propranolol (e.g. Inderal, InnoPran XL)'
      },
      {
        'molecule': 'Amitriptyline',
        'id': 'e9YWLTzrseHX',
        'ref': '68c4c723-c822-4a68-b1f0-37096895b6d7',
        'label': 'Amitriptyline (e.g. Elavil, Vanatrip, Endep)'
      },
      {
        'molecule': 'Erenumab',
        'id': 'fpVZ9wsWKwk7',
        'ref': 'ece161da-9c17-4fe9-a317-a62c18c65eb8',
        'label': 'Erenumab (e.g. Aimovig)'
      },
      {
        'molecule': 'Fremanezumab',
        'id': 'AUkhrD9QnTx0',
        'ref': '10372b53-c3a5-4234-8d7f-fbd565c04461',
        'label': 'Fremanezumab (e.g. Ajovy)'
      }
    ]

    let previousIndex = previousMedications.map(e => e.molecule.toLowerCase()).indexOf(molecule.toLowerCase())

    if (previousIndex > -1) {
      previousMedications.splice(previousIndex, 1)
    }

    let concurrentMedications = [
      {
        'molecule': 'Botox',
        'id': 'GfhMwANAhkqa',
        'ref': '9842b384-3070-455c-afb9-020efbf840f1',
        'label': 'Botulinum Toxin A (e.g. Botox)'
      },
      {
        'molecule': 'Topiramate',
        'id': 'OIHEbcL0NLhC',
        'ref': '482319a6-05b6-403a-a3a9-27b0f781f620',
        'label': 'Topiramate (e.g. Topamax, Trokendi XR)'
      },
      {
        'molecule': 'Propanolol',
        'id': 'IqcAN5Na88kQ',
        'ref': '8c48966c-5a1e-424f-8565-b98979b57666',
        'label': 'Propranolol (e.g. Inderal, InnoPran XL)'
      },
      {
        'molecule': 'Amitriptyline',
        'id': 'hmNpzEmyBJ47',
        'ref': '68c4c723-c822-4a68-b1f0-37096895b6d7',
        'label': 'Amitriptyline (e.g. Elavil, Vanatrip, Endep)'
      },
      {
        'molecule': 'Erenumab',
        'id': 'S8bn3uhChDmx',
        'ref': 'ece161da-9c17-4fe9-a317-a62c18c65eb8',
        'label': 'Erenumab (e.g. Aimovig)'
      },
      {
        'molecule': 'Fremanezumab',
        'id': 'Or1lUZ3GeWkn',
        'ref': '10372b53-c3a5-4234-8d7f-fbd565c04461',
        'label': 'Fremanezumab (e.g. Ajovy)'
      }
    ]

    let concurrentIndex = concurrentMedications.map(e => e.molecule.toLowerCase()).indexOf(molecule.toLowerCase())

    if (concurrentIndex > -1) {
      concurrentMedications.splice(concurrentIndex, 1)
    }

    let dosageChoices = []

    for (let i = 0; i < dosage.length; i++) {
      let idList = ['x9qp3MbpOabk', 'TZhSTvjuD2bI', 'x9uA7ChR8W1P']
      let refList = [
        'e0d4fd2b-78ef-4784-a215-d0cbcc98c64c',
        '39228fb6-e863-4c2d-87cf-55526b92fe77',
        '5dc4b040-c9a0-4be4-b2cc-fb1e8257c730'
      ]

      dosageChoices.push({
        'id': idList[i],
        'ref': refList[i],
        'label': dosage[i]
      })
    }

    this.fields = [
      {
        'id': 'oC7hqihuIY3G',
        'title': 'When did you start taking {{hidden:prophy}}?',
        'ref': '94969f61-8915-4f4b-87a6-ba2e08200ae1',
        'properties': {
          'description': 'Tap on the calendar header to change years',
          'structure': 'YYYYMMDD',
          'separator': '-'
        },
        'validations': {
          'required': true,
          'end_date': {
            'type': 'today'
          }
        },
        'type': 'date'
      },
      {
        'id': 'MAXKBozuJ6Mw',
        'title': 'How many <b>migraine days</b> did you experience in the 30 days <b>before starting {{hidden:prophy}}</b>? ({{calculated:humanStartDate}} to {{calculated:humanEndDate}})',
        'ref': '63fd0c45-0dbd-4756-930e-782fb1890445',
        'properties': {
          'description': 'Migraine days recorded: {{calculated:hintMigDays}}'
        },
        'validations': {
          'required': true,
          'max_value': 30
        },
        'type': 'number'
      },
      {
        'id': 'XOK6ouNszMhb',
        'title': 'How many <b>days of acute migraine medication</b> did you experience in the 30 days <b>before starting {{hidden:prophy}}</b>?',
        'ref': '7fc79113-33d7-4b14-803c-19de4a07de05',
        'properties': {
          'description': 'Estimated acute medication days: {{calculated:hintMedDays}}'
        },
        'validations': {
          'required': true,
          'max_value': 30
        },
        'type': 'number'
      },
      {
        'id': 'vgIK44QCf3q7',
        'title': 'How many different preventive medication have you <b>tried before</b> starting {{hidden:prophy}}?',
        'ref': 'ff55f1c8-1a39-4da0-b3b4-32d91064dd73',
        'validations': {
          'required': true
        },
        'type': 'number'
      },
      {
        'id': 'zaCVHATyBICj',
        'title': 'Which <b>previous preventive medication</b>(s) have you taken before starting {{hidden:prophy}}?',
        'ref': 'b65eb1b6-122d-49d8-a32c-5cdfac1da0da',
        'properties': {
          'randomize': true,
          'allow_multiple_selection': true,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': previousMedications
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'aa1UI0zDnMQ3',
        'title': 'Are you taking any <b>preventive medications at the same time</b> with {{hidden:prophy}}?',
        'ref': '4059dcdb-fd01-4f99-9190-b46a1286a098',
        'properties': {
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': false,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'BkJV1EQxgocq',
              'ref': '32c99c0e-580a-461c-9f45-8575e04d76f6',
              'label': 'Yes'
            },
            {
              'id': 'KmiQ0XeYl4Jz',
              'ref': '7b38e144-2b38-4e3a-a5f5-12b743653b4e',
              'label': 'No'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'iQxGAfEvKUNw',
        'title': 'Which preventive medication(s) are you taking together with {{hidden:prophy}}',
        'ref': '458756b0-d6a6-4fee-8cce-261f6f7a8b01',
        'properties': {
          'randomize': true,
          'allow_multiple_selection': true,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': concurrentMedications
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'wudVN0A6DXgr',
        'title': 'Which type of doctor prescribed {{hidden:prophy}}?',
        'ref': '9e76f628-2c14-45b0-85ab-6723bc77c652',
        'properties': {
          'randomize': true,
          'allow_multiple_selection': false,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'GDj61R4yiyw0',
              'ref': 'd375dcd4-12e0-4476-aef8-dced639f701a',
              'label': 'General Practitioner'
            },
            {
              'id': 'jn5mYXM8YmNr',
              'ref': '0c382241-b4c7-49de-a25a-884a6c81b4c2',
              'label': 'Neurologist'
            },
            {
              'id': 'APRWhCddSH13',
              'ref': '81ae436e-89e7-4736-9f80-3d65392e7913',
              'label': 'Headache Specialist'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'BnRwxxxHS4ez',
        'title': 'What dosage of {{hidden:prophy}} did you <b>start with</b>?',
        'ref': 'a73effa9-3e58-4e50-8bc6-77b03c6533e3',
        'properties': {
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': true,
          'vertical_alignment': true,
          'choices': dosageChoices
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'XgzJONzBO2Oi',
        'title': 'Is {{hidden:prophy}} covered by your current insurance?',
        'ref': '80dedc25-f506-4b31-93a6-dcb63bc89f8c',
        'properties': {
          'randomize': false,
          'allow_multiple_selection': false,
          'allow_other_choice': false,
          'vertical_alignment': true,
          'choices': [
            {
              'id': 'OilCWSFzSVCN',
              'ref': 'e39db925-27c4-412a-bd04-c042e535e490',
              'label': 'Yes, completely'
            },
            {
              'id': 'MwI5VmdOP2Fj',
              'ref': '86a6193c-9f91-4255-a6e1-5d6d604f957c',
              'label': 'Yes, more than half'
            },
            {
              'id': 'rPCBX0LZf1WJ',
              'ref': 'ff488299-9df2-475d-81a8-8fd23a9b99a5',
              'label': 'Yes, less than half'
            },
            {
              'id': 'tBYw7o1Nw0Me',
              'ref': 'b632bc1e-b4a7-4e09-a1bb-e3570dd6acfc',
              'label': 'Not at all'
            },
            {
              'id': 'oVHRP392EviU',
              'ref': '32ec19da-3820-4ddb-ae14-a00c0af95b6b',
              'label': "I don't have insurance"
            },
            {
              'id': 'J8R2j5Cojvqj',
              'ref': '7755a85d-c65a-4320-a29a-04b1f5bfadbe',
              'label': 'Not sure'
            }
          ]
        },
        'validations': {
          'required': true
        },
        'type': 'multiple_choice'
      },
      {
        'id': 'QM0aOxzzf2E0',
        'title': 'How would you rate the <b>impact of migraines on your work/school/housework activities</b> before {{hidden:prophy}}?',
        'ref': '1ebb17ab-abbf-4f3f-b611-e7a60c1f5d5a',
        'properties': {
          'steps': 6,
          'start_at_one': false,
          'labels': {
            'left': 'Not at all',
            'right': 'Severely affected'
          }
        },
        'validations': {
          'required': false
        },
        'type': 'opinion_scale'
      },
      {
        'id': 'VKMOg3H7gJbf',
        'title': 'How would you rate the <b>impact of migraines on your social activities</b> before {{hidden:prophy}}?',
        'ref': 'a52c9896-c0a6-4eb9-b24b-599a8de6b4a1',
        'properties': {
          'steps': 6,
          'start_at_one': false,
          'labels': {
            'left': 'Not at all',
            'right': 'Severely affected'
          }
        },
        'validations': {
          'required': false
        },
        'type': 'opinion_scale'
      },
    ]
    this.hidden = [
      'prophy',
      'recurring_order'
    ]
    this.logic = [
      {
        'type': 'field',
        'ref': 'ff55f1c8-1a39-4da0-b3b4-32d91064dd73',
        'actions': [
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '4059dcdb-fd01-4f99-9190-b46a1286a098'
              }
            },
            'condition': {
              'op': 'equal',
              'vars': [
                {
                  'type': 'field',
                  'value': 'ff55f1c8-1a39-4da0-b3b4-32d91064dd73'
                },
                {
                  'type': 'constant',
                  'value': 0
                }
              ]
            }
          },
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': 'b65eb1b6-122d-49d8-a32c-5cdfac1da0da'
              }
            },
            'condition': {
              'op': 'always',
              'vars': {
              }
            }
          }
        ]
      },
      {
        'type': 'field',
        'ref': '4059dcdb-fd01-4f99-9190-b46a1286a098',
        'actions': [
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '458756b0-d6a6-4fee-8cce-261f6f7a8b01'
              }
            },
            'condition': {
              'op': 'is',
              'vars': [
                {
                  'type': 'field',
                  'value': '4059dcdb-fd01-4f99-9190-b46a1286a098'
                },
                {
                  'type': 'choice',
                  'value': '32c99c0e-580a-461c-9f45-8575e04d76f6'
                }
              ]
            }
          },
          {
            'action': 'jump',
            'details': {
              'to': {
                'type': 'field',
                'value': '9e76f628-2c14-45b0-85ab-6723bc77c652'
              }
            },
            'condition': {
              'op': 'always',
              'vars': {
              }
            }
          }
        ]
      }
    ]
    this._links = {
      'display': 'https://healint.typeform.com/to/LQZm1U'
    }
  }
}

export default BaselineProphyQuestionnaire



// WEBPACK FOOTER //
// ./src/store/questionnaires/questionnaireConfig/BaselineProphyQuestionnaire.js